import React, { useState } from "react";
import SideNavigation from "../../components/dumb/projectManager/SideNavigation";
import useAuthEffect from "../../hook/useAuthEffect";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchProject, uploadProjectFile } from "../../redux/ducks/project";
import { fetchTitle } from "../../redux/ducks/title";
import { fetchTasksByProject } from "../../redux/ducks/task";
import { fetchGlossariesByProject } from "../../redux/ducks/glossary";
import useStatusThunk from "../../hook/useStatusThunk";
import useEffectWithoutLoad from "../../hook/useEffectWithoutLoad";
import { fetchMemoriesByProject } from "../../redux/ducks/memory";
import Tasks from "../../components/dumb/tables/Tasks";
import Glossaries from "../../components/dumb/tables/Glossaries";
import Memories from "../../components/dumb/tables/Memories";
import { fetchProjectAnalyses } from "../../redux/ducks/analysis";
import TrashProject from "../../components/smart/buttonPopups/TrashProject";
import RouteHeader from "../../components/dumb/RouteHeader";
import Analyses from "../../components/dumb/tables/Analyses";
import { extractIDsDataAsArray, mapData } from "../../helpers/mapRow";
import SetProjectName from "../../components/smart/buttonPopups/SetProjectName";
import SetPONumber from "../../components/smart/buttonPopups/SetPONumber";
import DeletePO from "../../components/smart/buttonPopups/DeletePO";

const ProjectRoute = ({ match }) => {

    const projectID = match.params.projectID;
    const dispatch = useDispatch();

    const project = useSelector(state => state.project.projects[projectID]);
    const title = useSelector(state => state.title?.titles[project?.titleID]);

    const [dispatchFetchProject, status, error] = useStatusThunk(fetchProject);


    //Tasks
    const projectTaskIDs = useSelector(state => state.project.projects[projectID]?.tasks);
    const tasks = useSelector(state => state.task.tasks);
    const [taskRows, setTaskRows] = useState([]);

    useEffectWithoutLoad(() => {
        if (projectTaskIDs && tasks) {
            setTaskRows(extractIDsDataAsArray(projectTaskIDs, tasks));
        }
    }, [projectTaskIDs, tasks]);

    //Glossaries
    const projectGlossaries = useSelector(state => state.project.projects[projectID]?.glossaries);
    const glossaries = useSelector(state => state.glossary.glossaries);
    const [glossaryRows, setGlossaryRows] = useState([]);

    useEffectWithoutLoad(() => {
        if (projectGlossaries) {
            setGlossaryRows(Object.keys(projectGlossaries).map(glossaryID => ({
                ID: glossaryID,
                ...glossaries[glossaryID],
                contractorWrite: projectGlossaries[glossaryID].contractorWrite
            })));
        }
    }, [projectGlossaries, glossaries]);

    //Memories
    const projectMemoryIDs = useSelector(state => state.project.projects[projectID]?.memories);
    const memories = useSelector(state => state.memory.memories);
    const [memoryRows, setMemoryRows] = useState([]);

    useEffectWithoutLoad(() => {
        if (projectMemoryIDs) {

            const tm = {};
            Object.keys(projectMemoryIDs).forEach(projectMemoryID => {
                tm[projectMemoryID] = {
                    ...memories[projectMemoryID],
                    penalty: projectMemoryIDs[projectMemoryID].penalty,
                    write: projectMemoryIDs[projectMemoryID].write
                }
            });

            setMemoryRows(mapData(tm));
        }
    }, [memories, projectMemoryIDs]);

    //Analyses
    const analyses = useSelector(state => state.analysis.analyses);
    const projectAnalyses = useSelector(state => state.project.projects[projectID]?.analyses);
    const [analysesRows, setAnalysesRows] = useState([]);

    //Fetch project data
    useAuthEffect(() => dispatchFetchProject({ projectID }), []);

    useEffectWithoutLoad(() => {
        if (status == "success") {
            dispatch(fetchTitle({ titleID: project.titleID }));
            dispatch(fetchTasksByProject({ projectID }));
            dispatch(fetchGlossariesByProject({ projectID }));
            dispatch(fetchMemoriesByProject({ projectID }));
            dispatch(fetchProjectAnalyses({ projectID }));
        }
    }, [status]);

    useEffectWithoutLoad(() => {
        if (projectAnalyses) {
            setAnalysesRows(extractIDsDataAsArray(projectAnalyses, analyses));
        }
    }, [projectAnalyses, analyses]);

    return (
        <div className="columns-container">
            <div className="column column--sidenav">
                <SideNavigation selected="projects" />
            </div>

            <div className="column column--primary">

                <RouteHeader title={<React.Fragment>{project?.name} <SetProjectName projectID={projectID}/></React.Fragment>} data={
                    {
                        title: <NavLink className="link link--primary" to={"/PM/title/" + project?.titleID}>{title?.name}</NavLink>,
                        created: project?.created,
                        "created by": project?.createdBy,
                        "po #": project?.orderNumber ? <span>{project.orderNumber} <React.Fragment><SetPONumber projectID={projectID}/></React.Fragment></span> : <br/>,
                        "file": project?.fileName ? <span>{project.fileName} <TrashProject projectID={projectID} /></span> : <input type="file" accept=".json,.xlsx,.docx" onChange={e => { dispatch(uploadProjectFile({ file: e.target.files[0], projectID })) }} />,
                        "": project?.fileName ? <a download href={`${window.API_URL}/project/exportNew.php?projectID=${projectID}`} className="button button--warm">Export</a> : "",
                        "Delete": <React.Fragment><br/><DeletePO projectID={projectID} rows={analysesRows} /></React.Fragment>,
                    }
                } />

                {(project && project.fileName) ? <Tasks projectID={projectID} rows={taskRows} /> : ""}

                <Analyses rows={analysesRows} projectID={projectID} />
                <Glossaries projectID={projectID} rows={glossaryRows} />
                <Memories projectID={projectID} rows={memoryRows} />

            </div>
        </div >
    )
}

export default ProjectRoute;